import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMyContext } from '../../../context/MyContext';
import { HiUsers } from "react-icons/hi";
import { FiEye, FiEyeOff } from 'react-icons/fi';
import '../../css/custom-scrollbar.css';
import { Base_Url,editemployeeApi } from '../../../config/config';
import { toast } from 'react-toastify';
import axios from 'axios';

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Password must be at least 8 characters"),
  department: z.string().min(1, "Department is required"),
  phone: z.string().length(10, "Phone number must be 10 digits"),
  role: z.string().min(1, "Role is required"),
  company_name: z.string().min(1, "Company name is required")
});

const ViewAllEmployees = ({ isopen, onClose, employee }) => {
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const {isDarkMode, setLoading } = useMyContext();
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditEmail, isSetEditEmail] = useState(true);
  const [isEditemployee_id, isSetEditemployee_id] = useState(true);
  const [isEditId, isSetEditId] = useState(true);
   const [showPassword, setShowPassword] = useState(false);
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm({
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (employee) {
      reset({
        id: employee.id || '',
        employee_id: employee.employee_id || '',
        name: employee.name || '',
        email: employee.email || '',
        phone: employee.phone || '',
        password: employee.password || '',
        role: employee.role || '',
        department: employee.department || '',
        company_name: employee.company_name || '',
      });
    }
  }, [employee, reset]);

  const onErrors = (errors) => {
    toast.error("Please fix the errors in the form.");
  };
const onSubmit = async (data) => {

  const editWarehouseurl = `${Base_Url}${editemployeeApi}/${employee.employee_id}`;

  try {
    const payload = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      company_name: data.company_name,
      password : data.password,
      role:data.role,
      department :data.department
    };

    // Making the API request with the payload
    const response = await axios.post(editWarehouseurl, payload, {
      headers: {
        'token': token,
        'cus_id': cusid,
        'Content-Type': 'application/json',
      },
    });

    if (response.data.status === "SUCCESS") {
      toast.success("Employees Details Update Successfully");
      setIsEditMode(false);
      onClose();
    } else {
      toast.error(response.data.message || 'Failed to update employee');
    }
  } catch (error) {
    toast.error(error.response?.data?.message || 'An error occurred while updating employee');
  }
};
  

  const handleClose = () => {
    setIsEditMode(false);
    onClose();
  };

  const hanldeAllEditFileds = () => {
    setIsEditMode(!isEditMode);
  }


  const handleInputChange = (event) => {
    const { value, id } = event.target;
    if (['pincode', 'phone', 'return-pincode'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;
    }
    if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
      event.target.value = filteredValue;

    }
  };

  return (
    <Dialog open={isopen} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle className="bg-customPurple text-white relative shadow-custom-light dark:shadow-custom-dark">
        <h2 className="text-xl sm:text-2xl font-bold text-white font-sans px-2 py-2 rounded-custom h-[40px] w-full sm:w-full flex items-center justify-center">
          <HiUsers className="mr-2" size={24} />
          All Employees Details
        </h2>
        <IoIosCloseCircle
          className="absolute top-0 right-0 cursor-pointer"
          size={32}
          onClick={handleClose}
        />
      </DialogTitle>

      <DialogContent className="bg-white custom-scrollbar dark:bg-darkmodeColor" style={{ maxHeight: '70vh' }}>
        <div className="p-4 m-4 bg-custom-background shadow-custom-light dark:bg-darkmodeColor dark:shadow-custom-dark dark:text-white rounded-custom-custom">
          <form className="space-y-6 font-sans"
             onSubmit={handleSubmit(onSubmit, onErrors)}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">ID</label>
                <input
                  type="text"
                  className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                  {...register('id')}
                  disabled={isEditId}
                />
                {errors.id && <p className="text-red-500 text-sm">{errors.id.message}</p>}
              </div>
              <div>
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">Employee ID</label>
                <input
                  type="text"
                  className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                  {...register('employee_id')}
                  disabled={isEditemployee_id}
                />
                {errors.employee_id && <p className="text-red-500 text-sm">{errors.employee_id.message}</p>}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">Name</label>
                <input
                  type="text"
                  className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                  {...register('name')}
                  disabled={!isEditMode}
                />
                {errors.name && <p className="text-red-500 text-sm">{errors.name.message}</p>}
              </div>
              <div>
                  <label className="block text-sm ml-2 font-bold text-black dark:text-white">Email</label>
                  <input
                    type="email"
                    className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                    {...register('email')}
                    disabled={isEditEmail}
                  />
                  {errors.email && <p className="text-red-500 text-sm">{errors.email.message}</p>}
                </div>
              </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">Phone</label>
                <input
                  type="tel"
                  className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                  {...register('phone')}
                  maxLength={10}
                  disabled={!isEditMode}
                />
                {errors.phone && <p className="text-red-500 text-sm">{errors.phone.message}</p>}
              </div>
              <div className="relative">
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">Password</label>

                <input
                  type={showPassword ? 'text' : 'password'}
                  className={`mt-2 p-2 pr-10 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""
                    }`}
                  {...register('password')}
                  disabled={!isEditMode}
                />

                <span
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 mt-[14px] cursor-pointer text-gray-600 dark:text-white"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </span>

                {errors.password && (
                  <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">Role</label>
                <input
                  type="text"
                  className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                  {...register('role')}
                  disabled={!isEditMode}
                />
                {errors.role && <p className="text-red-500 text-sm">{errors.role.message}</p>}
              </div>
              <div>
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">Department</label>
                <input
                  type="text"
                  className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                  {...register('department')} 
                  disabled={!isEditMode}
                />
                {errors.department && <p className="text-red-500 text-sm">{errors.department.message}</p>}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <div>
            <label className="block text-sm ml-2 font-bold text-black dark:text-white">Wallet Status</label>
            <input
              type="text"
              className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
              {...register('wallet_status')}
              disabled={!isEditMode}
            />
            {errors.wallet_status && <p className="text-red-500 text-sm">{errors.wallet_status.message}</p>}
          </div> */}
              <div>
                <label className="block text-sm ml-2 font-bold text-black dark:text-white">Company Name</label>
                <input
                  type="text"
                  className={`mt-2 p-2 border w-full rounded-custom focus:ring-1 focus:ring-customPurple ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                  {...register('company_name')}
                  disabled={!isEditMode}
                />
                {errors.company_name && <p className="text-red-500 text-sm">{errors.company_name.message}</p>}
              </div>
            </div>

            <button
              type="button"
              onClick={hanldeAllEditFileds}
              className="bg-customPurple text-white py-2 px-4 rounded-custom-custom hover:bg-customPurpleHover focus:outline-none focus:ring-2 focus:ring-customPurple focus:ring-opacity-50"
            >
              {isEditMode ? 'Cancel' : 'Edit'}
            </button>

            {(isEditMode && isEditId && isEditEmail && isSetEditemployee_id) ? (
              <button
                type="submit"
                className="bg-customPurple text-white py-2 px-4 md:ml-8 rounded-custom-custom mt-4 hover:bg-customPurpleHover focus:outline-none focus:ring-2 focus:ring-customPurple focus:ring-opacity-50"
              >
                Save
              </button>
            ) : ("")}

          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default ViewAllEmployees;
